module.exports = __webpack_public_path__ + "img/api-usage-icon.5daa1174.png";